import React from 'react';
import { Trash2 } from 'lucide-react';

// Editable review table for credit-sale lines pulled from a Tally import (or typed manually)
// before they're saved. Lets you fix vehicle/voucher/product/qty/rate/amount/cash on any row.
const CreditEntryReviewTable = ({ entries, onChangeField, onChangeItemName, onDelete }) => {
  const handleChange = (id, field, value) => {
    if (['quantity', 'rate', 'amount', 'cash_amount'].includes(field)) {
      onChangeField(id, field, value === '' ? '' : parseFloat(value));
    } else {
      onChangeField(id, field, value);
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="bg-slate-50 text-slate-500 text-sm border-b border-slate-200">
            <th className="p-4 font-medium">Date</th>
            <th className="p-4 font-medium">Party Name</th>
            <th className="p-4 font-medium">Vehicle No.</th>
            <th className="p-4 font-medium">Voucher No.</th>
            <th className="p-4 font-medium">Item</th>
            <th className="p-4 font-medium text-right">Qty (Ltr)</th>
            <th className="p-4 font-medium text-right">Rate</th>
            <th className="p-4 font-medium text-right">Amount (₹)</th>
            <th className="p-4 font-medium text-right">Cash (₹)</th>
            <th className="p-4 font-medium text-center">Action</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {entries.map((entry) => (
            <tr key={entry.id} className="hover:bg-slate-50/50 transition-colors">
              <td className="p-2">
                <input type="date" className="w-full bg-transparent border border-transparent hover:border-slate-200 focus:border-indigo-400 rounded px-2 py-1.5 text-sm"
                  value={entry.business_date || ''} onChange={e => handleChange(entry.id, 'business_date', e.target.value)} />
              </td>
              <td className="p-4 font-medium text-slate-900">{entry.party_name}</td>
              <td className="p-2">
                <input type="text" className="w-20 bg-transparent border border-transparent hover:border-slate-200 focus:border-indigo-400 rounded px-2 py-1.5 text-sm font-mono"
                  value={entry.vehicle_no || ''} onChange={e => handleChange(entry.id, 'vehicle_no', e.target.value)} />
              </td>
              <td className="p-2">
                <input type="text" className="w-28 bg-transparent border border-transparent hover:border-slate-200 focus:border-indigo-400 rounded px-2 py-1.5 text-sm font-mono"
                  value={entry.voucher_no || ''} onChange={e => handleChange(entry.id, 'voucher_no', e.target.value)} />
              </td>
              <td className="p-2">
                <select className="bg-transparent border border-transparent hover:border-slate-200 focus:border-indigo-400 rounded px-2 py-1.5 text-sm"
                  value={entry.item_name || ''} onChange={e => (onChangeItemName || ((id, v) => handleChange(id, 'item_name', v)))(entry.id, e.target.value)}>
                  <option value="">-</option>
                  <option value="Petrol">Petrol</option>
                  <option value="Diesel">Diesel</option>
                  <option value="Xtragreen">Xtragreen</option>
                  <option value="CASH">CASH</option>
                </select>
              </td>
              <td className="p-2">
                <input type="number" className="w-20 bg-transparent border border-transparent hover:border-slate-200 focus:border-indigo-400 rounded px-2 py-1.5 text-sm text-right font-mono"
                  value={entry.quantity ?? ''} onChange={e => handleChange(entry.id, 'quantity', e.target.value)} />
              </td>
              <td className="p-2">
                <input type="number" step="0.01" className="w-20 bg-transparent border border-transparent hover:border-slate-200 focus:border-indigo-400 rounded px-2 py-1.5 text-sm text-right font-mono"
                  value={entry.rate ?? ''} onChange={e => handleChange(entry.id, 'rate', e.target.value)} />
              </td>
              <td className="p-2">
                <input type="number" className="w-24 bg-transparent border border-transparent hover:border-slate-200 focus:border-indigo-400 rounded px-2 py-1.5 text-sm text-right font-mono font-medium"
                  value={entry.amount ?? ''} onChange={e => handleChange(entry.id, 'amount', e.target.value)} />
              </td>
              <td className="p-2">
                <input type="number" className="w-24 bg-transparent border border-transparent hover:border-slate-200 focus:border-indigo-400 rounded px-2 py-1.5 text-sm text-right font-mono font-medium text-amber-700"
                  value={entry.cash_amount ?? ''} onChange={e => handleChange(entry.id, 'cash_amount', e.target.value)} />
              </td>
              <td className="p-4 text-center">
                <button
                  onClick={() => onDelete(entry.id)}
                  className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                >
                  <Trash2 size={18} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="bg-slate-50 border-t border-slate-200">
          <tr>
            <td colSpan="7" className="p-4 text-right font-bold text-slate-700">Total:</td>
            <td className="p-4 text-right font-bold text-indigo-700 font-mono text-lg">
              {entries.reduce((sum, e) => sum + (e.amount || 0), 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </td>
            <td className="p-4 text-right font-bold text-amber-700 font-mono text-lg">
              {entries.reduce((sum, e) => sum + (e.cash_amount || 0), 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default CreditEntryReviewTable;
